import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { db } from '../firebase';

/**
 * Renders links to KB activities by slug.
 */
export default function KbResourceLinks({ slugs = [], className = '' }) {
  const [items, setItems] = useState([]);
  const uniqueSlugs = [...new Set((slugs || []).filter(Boolean))];

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!uniqueSlugs.length) {
        setItems([]);
        return;
      }
      try {
        const results = await Promise.all(
          uniqueSlugs.slice(0, 5).map(async (slug) => {
            const q = query(collection(db, 'kb_items'), where('slug', '==', slug));
            const snap = await getDocs(q);
            if (!snap.empty) {
              const data = snap.docs[0].data();
              return { slug, title: data.title || slug, id: snap.docs[0].id };
            }
            return { slug, title: slug, id: slug };
          })
        );
        if (!cancelled) setItems(results);
      } catch (e) {
        console.warn('KbResourceLinks load failed', e);
        if (!cancelled) setItems(uniqueSlugs.map((slug) => ({ slug, title: slug, id: slug })));
      }
    };
    load();
    return () => { cancelled = true; };
  }, [uniqueSlugs.join('|')]);

  if (!uniqueSlugs.length) return null;

  return (
    <div className={`rounded-md border border-indigo-100 bg-indigo-50/50 p-3 ${className}`}>
      <p className="text-xs font-semibold uppercase tracking-wide text-indigo-700">Knowledge base resources</p>
      <ul className="mt-2 space-y-1">
        {items.map((item) => (
          <li key={item.slug}>
            <Link
              to={`/solo/activity/${item.id}`}
              className="text-sm text-indigo-700 hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
